module.exports = __webpack_public_path__ + "components/flag/static/square/sc-3df1b7eb46a4ea80b12973bc86cedd9a.svg";